import { SkeletonTitle, SkeletonText, SkeletonButton, SkeletonImage } from '@pixum/skeleton';
import './styles.css';

/**
 * MentionMeSkeleton
 *
 * Skeleton placeholder component for the Mention Me referral widget.
 * Displays a responsive layout matching the expected MentionMe content structure.
 *
 * Layout:
 * - Desktop: Two-column layout with content (title, text, button) on left and image on right
 * - Mobile: Single-column stacked layout with image on top and content below
 *
 * This component is rendered inside the #mmWrapper container and automatically
 * removed by MentionMeController when the actual MentionMe content loads.
 *
 * Accessibility:
 * - Uses role="status" to announce loading state to screen readers
 * - aria-busy="true" indicates content is loading
 * - aria-label provides clear description of what is loading
 * - Individual skeleton elements marked with aria-hidden to prevent redundant announcements
 *
 * @returns A responsive skeleton layout with accessibility support
 */
export function MentionMeSkeleton() {
  return (
    <div className="mention-me-skeleton" role="status" aria-busy="true" aria-label="Loading referral program content">
      <div className="mention-me-skeleton__column">
        <SkeletonTitle size="xlarge" aria-hidden="true" />
        <SkeletonText lines={5} aria-hidden="true" />
        <SkeletonButton aria-hidden="true" />
      </div>

      <div className="mention-me-skeleton__column mention-me-image">
        <SkeletonImage aria-hidden="true" />
      </div>
    </div>
  );
}
